const ar = {
  avisoLegal: "مسودة استرشادية مُعدّة من البيانات المسجّلة في NuvliPro. لا تغني عن الاستشارة المهنية. راجعها مع محاسبك قبل تقديمها.",
  lockPago: "التصدير للمحاسب ميزة مدفوعة.",
  imp: { IVA: "ض.ق.م", IGIC: "IGIC", IPSI: "IPSI" },
  ter: { comun: "الإقليم العام", canarias: "جزر الكناري", ceuta_melilla: "سبتة ومليلية", foral_pv: "إقليم الباسك", foral_navarra: "نافارا" },
  tipo: { autonomo: "عامل مستقل (شخص طبيعي)", sociedad: "شركة" },
  q: { 1: "الربع 1 · يناير–مارس", 2: "الربع 2 · أبريل–يونيو", 3: "الربع 3 · يوليو–سبتمبر", 4: "الربع 4 · أكتوبر–ديسمبر" },
  periodoT: "الربع {{n}} {{year}}",
  periodoP: "الدفعة {{n}} {{year}}",
  sub: "{{imp}} وضريبة الدخل لكل ربع مع ملخص سنوي",
  pie: "تُحسب المبالغ تلقائيًا من الفواتير الصادرة والمصروفات المسجّلة في كل ربع.",
  regimen: {
    proTitulo: "خطة Pro:",
    proTexto: "نظام ضريبي تلقائي حسب الإقليم (ض.ق.م وIGIC والهيئات الضريبية الفورالية)، النموذج 420 في جزر الكناري، النموذج 202 للشركات، النموذج 111، تذكير بالمواعيد ومراجعة جودة البيانات.",
    pasarPro: "الترقية إلى Pro",
    modelo: " (النموذج {{m}})",
    pagos: "الدفعات المقدّمة: النموذج {{m}}",
    corregido: "مُصحَّح يدويًا · تغيير",
    detectado: "مُكتشَف تلقائيًا · تصحيح",
    faltan: "تنقصك بيانات ضريبية ({{que}}): افترضنا الإقليم العام وعاملًا مستقلًا إلى أن تُكملها.",
    cp: "الرمز البريدي", nif: "NIF/CIF", y: " و",
    foral: "عنوانك الضريبي في {{nombre}}: تُقدَّم ض.ق.م والدفعات المقدّمة إلى {{hacienda}} بنماذجها ومواعيدها الفورالية الخاصة. هذه المسودة للاسترشاد؛ يُعدّ محاسبك الإقرار.",
    ipsi: "في سبتة ومليلية تُطبَّق ضريبة IPSI بدلًا من ض.ق.م. لا يحسبها NuvliPro بعد: اطلب من محاسبك إعداد الإقرار.",
  },
  card: {
    baseVentas: "أساس المبيعات", baseGastos: "أساس المصروفات", rep: "{{imp}} المحصّلة", sop: "{{imp}} المدفوعة",
    irpf: "ضريبة الدخل المقتطعة (IRPF)", horas: "ساعات العمل", bases: "الأسس حسب نسبة {{imp}}", base: "{{imp}} {{pct}}% · الأساس",
    resultado: "نتيجة {{imp}} ({{estado}})", aIngresar: "مستحقة الدفع", aCompensar: "للتعويض",
    igicCanarias: "IGIC · مشاريع في جزر الكناري", ivaFuera: "ض.ق.م · مشاريع خارج جزر الكناري",
    ipsiRep: "IPSI المحصّلة", ipsiAviso: "IPSI بدون حساب: يُعدّها محاسبك.",
    isp: "الاحتساب العكسي · منفصل", ispEmitidas: "صادرة (الأساس، بدون ضريبة)", ispRecibidas: "واردة (الأساس)",
    ispCuota: "ضريبة مُحتسبة ذاتيًا (تُصرَّح وتُخصَم)",
  },
  btn: {
    docGestoria: "مستند المحاسب", docAnual: "مستند المحاسب (سنوي)", enviar: "إرسال", m: "ن.{{m}}", modelo: "النموذج {{m}}",
    m420Pro: "النموذج 420: خطة Pro", excel: "Excel", ver130: "عرض 130",
  },
  anual: { titulo: "الملخص السنوي {{year}}", ipsi: "IPSI المحصّلة (بدون حساب)", resultado: "النتيجة السنوية لـ{{imp}}" },
  doc: { gestoria: "مستند للمحاسب", modelo: "النموذج {{m}}" },
  toast: {
    generado: "تم إنشاء {{doc}}", trimestre: " (الربع {{n}})", anual: " (سنة {{year}})", error: "تعذّر الإنشاء: {{doc}}",
    excelOk: "تم تصدير تقرير {{year}} للمحاسب (XLSX)", excelError: "تعذّر تصدير التقرير",
    m130Error: "تعذّر حساب النموذج 130", reduccionError: "تعذّر حفظ التخفيض",
  },
  m130: {
    titulo: "النموذج 130 — ضريبة الدخل", acum: "(تراكمي حتى الربع {{n}})", anual: "(سنة {{year}})",
    desc: "الدفعة المقدّمة التراكمية للسنة، مطروحًا منها الاقتطاعات وما دُفع في الأرباع السابقة.",
    ingresos: "الإيرادات المحتسبة (تراكمي)", gastos: "المصروفات القابلة للخصم (تراكمي)", rendimiento: "صافي الدخل",
    reduccion: "تخفيض {{pct}} % للمصروفات صعبة الإثبات", pago: "الدفعة المقدّمة ({{pct}} %)",
    retenciones: "الاقتطاعات المتحمَّلة", anteriores: "دفعات الأرباع السابقة",
    aIngresar: "النتيجة المستحقة الدفع", negativo: "نتيجة سالبة (المستحق: 0 €)",
    marcar: "طبّق تخفيض {{pct}} % للمصروفات صعبة الإثبات (بحد أقصى {{max}} سنويًا). استشر محاسبك.",
    cerrar: "إغلاق", pdf: "تنزيل PDF",
  },
  m202: {
    titulo: "النموذج 202 — الدفعات المقدّمة {{year}} (تقدير)",
    desc: "ضريبة الشركات: {{pct}} % من الربح التراكمي للسنة. قد يستخدم محاسبك طريقة أخرى.",
    plazo: "الدفعة {{p}} · تُقدَّم من 1 إلى 20 {{mes}}", mes: { 1: "أبريل", 2: "أكتوبر", 3: "ديسمبر" },
    tramo: { 3: "يناير–مارس", 9: "يناير–سبتمبر", 11: "يناير–نوفمبر" }, beneficio: "الربح التراكمي ({{tramo}})",
    cuota: "{{pct}} % من الربح", menos: "الاقتطاعات والدفعات السابقة", estimacion: "المبلغ التقديري المستحق",
  },
  m111: {
    titulo: "النموذج 111 — الاقتطاعات {{year}}",
    desc: "اقتطاعات الرواتب (تُدخلها بنفسك) واقتطاعات المهنيين الذين تدفع لهم مع اقتطاع (من مصروفاتك).",
    nominas: "اقتطاعات الرواتب (يدويًا)", profesionales: "المهنيون: {{n}} مستفيد، الأساس {{base}}",
    total: "الإجمالي المستحق", guardado: "تم حفظ اقتطاعات رواتب الربع {{n}}",
    errorGuardar: "تعذّر حفظ المبلغ", invalido: "أدخل مبلغًا صحيحًا، مثل 1234.56",
  },
  enviar: {
    titulo: "إرسال الربع {{n}} {{year}} إلى محاسبك",
    desc: "سيصله بريد إلكتروني بهذه الملفات PDF مرفقة. إذا ردّ، يصلك الرد أنت.",
    email: "البريد الإلكتروني للمحاسب", placeholder: "accountant@example.com", boton: "إرسال", ok: "تم إرسال الربع {{n}} {{year}} إلى {{email}} ({{docs}} PDF)",
    error: "تحقّق من البريد الإلكتروني للمحاسب",
  },
  avisos: {
    plazos: "المواعيد القادمة", sinPlazos: "لا توجد مواعيد قادمة.",
    forales: "المواعيد الفورالية: تُقدَّم النماذج إلى الهيئة الضريبية الفورالية ويُعدّها محاسبك.",
    modelos: "النماذج {{m}}", rango: "{{periodo}}: من {{desde}} إلى {{hasta}}",
    hoy: "ينتهي اليوم", unDia: "بقي يوم واحد", dias: "بقي {{n}} يوم",
    recordatorio: "نذكّرك بإشعار وبريد إلكتروني قبل 10 أيام من انتهاء كل موعد.",
    calidad: "جودة البيانات {{year}}", ok: "كل شيء على ما يرام: لا توجد بيانات ناقصة في فواتير هذا العام.",
    revisar: "مراجعة", exenta: "تعليم كمعفاة", exentaOk: "تم تعليم المصروف كمعفى", exentaError: "تعذّر تعليم المصروف",
  },
  calidad: {
    facturas_nif: "فواتير صادرة بدون NIF للعميل أو برقم غير صحيح",
    facturas_cp_obra: "فواتير مشاريع بدون الرمز البريدي للمشروع (أضِفه في بطاقة المشروع)",
    gastos_sin_impuesto: "فواتير واردة بدون تفصيل الضريبة (ض.ق.م أو IGIC بقيمة 0)",
    gastos_nif: "فواتير واردة بدون NIF للمورّد أو برقم غير صحيح",
  },
  ajustes: {
    titulo: "النظام الضريبي (التقرير الفصلي)", det1: "مُكتشَف تلقائيًا:", det2: "من رمزك البريدي و",
    det3: "من رقم NIF/CIF الخاص بك. غيّره فقط إذا كان غير صحيح.",
    nota: "يؤثر هذا التغيير على التقرير الفصلي فقط. تواصل الفواتير الجديدة اقتراح الضريبة حسب رمزك البريدي ورمز العميل.",
    territorio: "الإقليم الضريبي", tipo: "نوع المكلَّف", automatico: "تلقائي ({{x}})",
    autonomo130: "عامل مستقل (النموذج 130)", sociedad202: "شركة (النموذج 202)",
    bloqueado: "النظام التلقائي جزء من خطة Pro.", guardado: "تم حفظ النظام الضريبي", error: "تعذّر الحفظ",
  },
};

export default ar;
